import PageLoader from "components/general/PageLoader";
import RoleForm from "components/form/RoleForm";
import { Box, Button, H1, Text, View } from "components/ui";
import { useLocalSearchParams } from "expo-router";
import { Formik } from "formik";
import React from "react";
import { TextInput } from "react-native";
import { useGetGroupRoleByIdQuery, usePutGroupRoleByIdMutation } from "store/abcoApi";
export default function Page() {
	const { id } = useLocalSearchParams<{ id: string }>();
	const [putRole, { isLoading: isSaving }] = usePutGroupRoleByIdMutation();

	const {
		data: role,
		isLoading,
		isFetching,
		isError,
	} = useGetGroupRoleByIdQuery({
		id: Number(id),
	});

	if (role == null && isFetching) {
		return (
			<Box minHeight={500}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<H1>Role Details</H1>

			<RoleForm groupRole={role} isNew={false} />
		</Box>
	);
}
